import React from 'react'

function NotFound() {
    return (
        <div id="main">
            <div class="fof">
                <h1>NOT FOUND 404</h1>
            </div>
        </div>
    )
}

export default NotFound
